export enum CreditCardNetwork {
  VISA = 'VISA',
  MAST = 'MASTERCARD',
  DISC = 'DISCOVER',
  AMEX = 'AMEX',
}

export const CardNetworksList = {
  [CreditCardNetwork.VISA]: 'Visa',
  [CreditCardNetwork.MAST]: 'Master Card',
  [CreditCardNetwork.DISC]: 'Discover',
  [CreditCardNetwork.AMEX]: 'Amex',
} as const;

export interface ICreditCard {
  name?: string | null;
  cardNetwork?: CreditCardNetwork | null;
  issuerBank?: string | null;
  lastFour?: string | null;
}
